<button type="button" class="btn {{typeClass}}" [ngClass]="{'d-block w-100': blockDisplay}" [disabled]="disabled">
  <ng-content></ng-content>
</button>